var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26692_160177)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 1.83594C4.59685 1.83594 1.83594 4.59685 1.83594 8.0026C1.83594 11.4084 4.59685 14.1693 8.0026 14.1693C11.4084 14.1693 14.1693 11.4084 14.1693 8.0026C14.1693 4.59685 11.4084 1.83594 8.0026 1.83594ZM0.835938 8.0026C0.835938 4.04456 4.04456 0.835938 8.0026 0.835938C11.9606 0.835938 15.1693 4.04456 15.1693 8.0026C15.1693 11.9606 11.9606 15.1693 8.0026 15.1693C4.04456 15.1693 0.835938 11.9606 0.835938 8.0026ZM8.0026 4.83594C8.27875 4.83594 8.5026 5.0598 8.5026 5.33594V7.5026H10.6693C10.9454 7.5026 11.1693 7.72646 11.1693 8.0026C11.1693 8.27875 10.9454 8.5026 10.6693 8.5026H8.5026V10.6693C8.5026 10.9454 8.27875 11.1693 8.0026 11.1693C7.72646 11.1693 7.5026 10.9454 7.5026 10.6693V8.5026H5.33594C5.0598 8.5026 4.83594 8.27875 4.83594 8.0026C4.83594 7.72646 5.0598 7.5026 5.33594 7.5026H7.5026V5.33594C7.5026 5.0598 7.72646 4.83594 8.0026 4.83594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26692_160177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.fc76357ba9898e0de542ed6ab9c03332.svg";
export { ForwardRef as ReactComponent };